import { apiClient } from './apiClient';

export const VerificationService = {
  sendSignupEmailOtp: async (email: string) => {
    const response = await apiClient.post('/verification/signup/email/send', { email });
    return response.data;
  },
  verifySignupEmailOtp: async (email: string, code: string) => {
    const response = await apiClient.post('/verification/signup/email/verify', { email, code });
    return response.data;
  },
  sendSignupPhoneOtp: async (phoneNumber: string) => {
    const response = await apiClient.post('/verification/signup/phone/send', { phoneNumber });
    return response.data;
  },
  verifySignupPhoneOtp: async (phoneNumber: string, code: string) => {
    const response = await apiClient.post('/verification/signup/phone/verify', { phoneNumber, code });
    return response.data;
  },

  sendPasswordResetEmailOtp: async (email: string) => {
    const response = await apiClient.post('/verification/password-reset/email/send', { email });
    return response.data;
  },
  verifyPasswordResetEmailOtp: async (email: string, code: string) => {
    const response = await apiClient.post('/verification/password-reset/email/verify', { email, code });
    return response.data;
  },
  sendPasswordResetPhoneOtp: async (phoneNumber: string) => {
    const response = await apiClient.post('/verification/password-reset/phone/send', { phoneNumber });
    return response.data;
  },
  verifyPasswordResetPhoneOtp: async (phoneNumber: string, code: string) => {
    const response = await apiClient.post('/verification/password-reset/phone/verify', { phoneNumber, code });
    return response.data;
  },
};

export default VerificationService;

